import React from "react";

import Layout from '@components/layout';
import ReviewsGuidelinesTemplate from "@components/reviewsGuidelinesPage/reviewsGuidelinesTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <ReviewsGuidelinesTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
